import { render, staticRenderFns } from "./CountryList.vue?vue&type=template&id=ce72ccd2&scoped=true"
import script from "./CountryList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountryList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CountryList.vue?vue&type=style&index=0&id=ce72ccd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce72ccd2",
  null
  
)

export default component.exports